import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private translations: any;
  private currentLanguage = new BehaviorSubject<string>("");

  constructor(private http: HttpClient) {}

  setLanguage(lang: string): void {
    if (lang.toLowerCase() !== this.currentLanguage.getValue()) {
      this.currentLanguage.next(lang.toLowerCase());
      this.loadTranslations(lang.toLowerCase());
    }
  }

  getLanguage(): Observable<string> {
    return this.currentLanguage.asObservable();
  }

  private loadTranslations(lang: string): void {
    this.http
      .get(`/assets/i18n/messages.${lang}.json`)
      .pipe()
      .subscribe(
        (data: any) => {
          if (data) {
            this.translations = data.translations;
          }
        },
        (error) => {
          console.error(`Could not load ${lang} translations`, error);
        }
      );
  }

  translate(key: string): string {
    return this.translations[key] || key;
  }
}
